export const PROBLEM_SOLVE = {
    STOW_FAILURE_INVALID_PACKAGE_STATE: "STOW_FAILURE_INVALID_PACKAGE_STATE",
    STOW_FAILURE: "STOW_FAILURE",
    WRONG_AISLE_CLUSTER: "WRONG_AISLE_CLUSTER",
    DAMAGED: "DAMAGED",
    PACKAGE_DOESNT_FIT: "STOW_OVERSIZE"
}
